import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ConversationComponentTypes = {
  MESSAGE: 'message',
  CONFIRMATION_OPTIONS: 'confirmation_options',
} as const

export type ConversationComponentTypeEnum = Enum<
  typeof ConversationComponentTypes
>
